import { render, staticRenderFns } from "./ArtRecommendation.vue?vue&type=template&id=c77955f8&scoped=true"
import script from "./ArtRecommendation.vue?vue&type=script&lang=js"
export * from "./ArtRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ArtRecommendation.vue?vue&type=style&index=0&id=c77955f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77955f8",
  null
  
)

export default component.exports